// extracted by mini-css-extract-plugin
export var border = "textandtext-module--border--f6a46";
export var heading = "textandtext-module--heading--6dfab";
export var listCheckIcon = "textandtext-module--listCheckIcon--498b4";
export var rightColumn = "textandtext-module--rightColumn--312a8";
export var subHeading = "textandtext-module--subHeading--81d8d";